<div class="page">
  <app-page-title [title]="title()" class="page__title" />

  @if (subheader()) {
    <app-page-subheader>
      {{ subheader() }}
    </app-page-subheader>
  }
  @if (!loading()) {
    <div class="page__content">
      <ng-content select="page-content" />
    </div>
  } @else {
    <div class="page__spinner">
      <app-spinner />
    </div>
  }
  <div class="page__footer">
    @if (footerText()) {
      <p class="page__footer-text">{{ footerText() }}</p>
    }
    <ng-content select="page-footer" />
  </div>
</div>
